module.exports = __webpack_public_path__ + "media/img/event/Sponsor-UCAM-f083f200db246bcf61b77dca4f623beb.jpg";